import { useMemo } from 'react';
import { QueryHookOptions } from '@apollo/client';

import {
  PaginationHandler,
  PaginationInfo,
  usePaginatedQuery,
} from '@occc-app/hooks/usePaginatedQuery';
import {
  GetSubmissionGroupLocationsQueryVariables,
  useGetSubmissionGroupLocationsQuery,
  GetSubmissionGroupLocationsQuery,
} from '@occc/graphql';

type UseGetSubmissionGroupLocationsParams = {
  search?: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  baseOptions?: QueryHookOptions<
    GetSubmissionGroupLocationsQuery,
    GetSubmissionGroupLocationsQueryVariables
  >;
};

export const useGetSubmissionGroupLocations = ({
  search,
  paginationInfo,
  onPageChange,
  baseOptions,
}: UseGetSubmissionGroupLocationsParams) => {
  const response = usePaginatedQuery(
    useGetSubmissionGroupLocationsQuery,
    'locations.pageInfo',
    undefined,
    {
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter: search
          ? { siteInfoSearch: search, ...baseOptions?.variables?.filter }
          : baseOptions?.variables?.filter,
      },
    },
    paginationInfo,
    onPageChange,
  );

  const data = useMemo(() => {
    return response.data ? response.data.locations.edges?.map((edge) => edge.node) : undefined;
  }, [response.data]);

  return {
    ...response,
    data,
  };
};
